import { DownloadOutlined, GiftOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, ConfigProvider, DatePicker, Input } from 'antd';
import { SearchProps } from 'antd/es/input';
import dayjs from 'dayjs';
import React, { Fragment } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { IVoucher, getListVoucher } from '../../../api/voucher/voucherApi';
import { LIMIT_EXPORT_EXCEL } from '../../../env';
import useThrottle from '../../../hook/useThrottle';
import useToast from '../../../hook/useToast';
import { statusVoucher, typeReduced, typeVoucher } from '../../../services/data';
import './VoucherFilterBlock.scss';
import viVN from 'antd/locale/vi_VN';
import { getPermissionClass, getUserPermissions } from '../../../until';
import { useSelector } from 'react-redux';
import { selectorPermission } from '../../../store/slices/permissionSlice';

const { RangePicker } = DatePicker;
const { Search } = Input;

const onSearch: SearchProps['onSearch'] = (value, _e, info) => {
  // console.log(info?.source, value);
}

interface Props {
  issuedUnitId: number | undefined
  selectedTab: "0" | "1" | "2"
  dataFilter: { name: string; date: string[]; }

  setDataFilter: (value: { name: string; date: string[]; }) => void

  exportExcel?: (data: any) => void
}

const VoucherFilterBlock: React.FC<Props> = ({
  issuedUnitId, selectedTab, dataFilter,
  setDataFilter, exportExcel
}) => {

  const location = useLocation()

  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, download, upload } = getUserPermissions(permissionSlice, location.pathname)
  const pushToast = useToast();
  const navigate = useNavigate()

  const onDateChange1 = (date: any, dateString: string[], info: any) => {
    if (dateString[0].length === 0 && dateString[1].length === 0) {
      onDateChange(date, dateString, info)
    }
    if (dateString[0].length && dateString[1].length) {
      onDateChange(date, dateString, info)
    }

  }

  const onDateChange = useThrottle((date: any) => {
    if (date?.[0] && date?.[1]) {
      setDataFilter({
        ...dataFilter,
        date: [date[0].format('YYYY-MM-DD'), date[1].format('YYYY-MM-DD')]
      });
    } else {
      setDataFilter({
        ...dataFilter,
        date: ["", ""]
      });
    }
  }, 2000)

  const gListVoucherByExcel = useThrottle(async () => {
    const result = await getListVoucher(
      LIMIT_EXPORT_EXCEL, undefined, issuedUnitId, dataFilter.name, dataFilter.date[0], dataFilter.date[1]
    )
    if (result?.status) {
      formattedDataExcel(result.data)
    } else {
      pushToast(result?.message, "warning")
    }


  }, 1000)

  const formattedDataExcel = (data: IVoucher[]) => {
    const formattedData = data.map((item) => {
      return {
        "Mã": item.code,
        "Tiêu đề": item.title,
        "Mô tả": item.description,
        "Ngày bắt đầu": item.dateStart,
        "Ngày kết thúc": item.dateStart,
        // "Giờ bắt đầu": item.timeStart,
        // "Giờ kết thúc": item.timeEnd,
        // "Số lượng": item.quantity,
        // "Trạng thái": statusVoucher[item.status ?? 0].label,
        // "Giá trị đơn hàng": item.orderValue,
        // "Số tiền giảm": item.reducedAmount,
        // "Phần trăm giảm": item.percentDecrease,
        // "Số tiền giảm tối đa": item.reducedAmountMaximum,
        // "Số lần áp dụng": item.usageCount,
        // "Giảm theo": typeReduced[item.role].label,
        // "Loại": typeVoucher[item.type].label,
      }
    }
    );
    exportExcel?.(formattedData)
  }

  return (
    <div className="custom-page-css flex items-center gap-3">
      <Fragment>
        {/* <Search
              placeholder="Tìm chương trình Voucher"
              allowClear
              className='custom-page-css h-full flex flex-2'
              // onSearch={onSearch}
              value={dataFilter.finished.name}
              onChange={(e) => setFilterName(e.target.value)}
            /> */}
        <div className='custom-page-css h-full flex flex-2'>
          <div className="custom-page-css custom-input-search w-full flex items-center justify-between flex-2 border bg-FCFCFD rounded-2  pl-3  overflow-hidden">
            <input
              placeholder="Tìm chương trình Voucher"
              className=' border-none custom-page-css w-full '
              value={dataFilter.name}
              onChange={(e) => setDataFilter({ ...dataFilter, name: e.target.value })}
            />
            <div className="border-l-F2F4F7 h-full d-flex align-center">
              <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
            </div>
          </div>
        </div>

        <ConfigProvider locale={viVN}>
          <RangePicker
            format={'DD/MM/YYYY'}
            className="custom-input-date"
            popupClassName="rs-range-picker-dropdown"
            placeholder={['Chọn từ ngày', 'Đến ngày']}
            value={dataFilter.date[0].length > 1 ? [dayjs(dataFilter.date[0]), dayjs(dataFilter.date[1])] : null}
            onChange={onDateChange}
          />
        </ConfigProvider>
        <Button
          className={`${getPermissionClass(upload)} custom-page-css flex items-center gap-2 py-1 px-2 rounded border`}
        >
          <UploadOutlined />
          <span>Nhập DS</span>
        </Button>

        <Button
          className={`${getPermissionClass(download)} custom-page-css flex items-center gap-2 py-1 px-2 rounded border`}
          onClick={gListVoucherByExcel}
        >
          <DownloadOutlined />
          <span>Xuất DS</span>
        </Button>

        <div
          className={`${getPermissionClass(add)} custom-page-css h-full flex items-center gap-2 px-2 rounded border bg-096DD9 text-white cursor-pointer`}
          onClick={() => navigate("/marketing/vouchers-management/add")}
        >
          <GiftOutlined />
          <span className='custom-page-css text-nowrap'>Tạo mới</span>
        </div>
      </Fragment>



    </div>
  );
}

export default VoucherFilterBlock;
